<template>
    <div @click="closeModal" class="addon-modal-page" :class="!showModal ? 'collapsed' : ''">
        <div v-if="selectedAddon"  id="addonModal" ref="addonModal" v-on:click.stop class="addon-modal-container" :class="!showModal ? 'collapsed' : ''">
            <div class="empty-space" @touchstart="dragStart" @touchend="dragEnd">
                <img @click="closeModal" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            </div>
            <div class="addon-container">
                <div v-if="selectedAddon.images.length < 2" class="images-container">
                    <span v-if="mainBadge != null" class="main-badge">{{mainBadge}}</span>
                    <img :src="currentMainImage" class="main-image">
                </div>
                <div id="images-carousel" class="images-container" v-else>
                <span v-if="mainBadge != null" class="main-badge">{{mainBadge}}</span>
                <VueSlickCarousel :infinite="true" :dots="true" :arrows="true" :slidesToShow="1" :slidesToScroll="1">
                    <template #prevArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648">
                        </div>
                    </template>
                    <div v-for="image in selectedAddon.images" :key="image.id">
                        <img class="main-image" :src="image.src"/>
                    </div>
                    <template #nextArrow="arrowOption">
                        <div>
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648">
                        </div>
                    </template>
                </VueSlickCarousel>
                </div>
                <div class="data-container">
                        <p class="title">{{selectedAddon.title}}</p>
                        <div v-if="hasVariants" class="variant-container">
                            <p class="variant-title">{{this.selectedAddon.options[0].name}}:</p>
                            <div class="variants-button-container">
                                <button :class="selectedVariant == i ? 'selected' : ''" @click="selectVariant(i)" v-for="(variant,i) in this.selectedAddon.variants" :key="variant.id">
                                    {{variant.title.slice(0,1)}}
                                </button>
                            </div>
                        </div>
                        <div v-if="ethosTags.length > 0 || showOnDemand" class="ethos-container">
                            <span :class="badgeExtraClass(etho)" v-for="etho in ethosTags" :key="etho">{{etho}}</span>
                            <span class="purple-ethos" v-if="showOnDemand">Ships in 1-2 weeks</span>
                        </div>
                        <p class="desc-label">Description</p>
                        <p class="desc" v-html="productDesc"></p>
                        <div class="alergen-container">
                            <span v-for="dietary in dietaryTags" :key="dietary">{{dietary}}</span>
                        </div>
                        <div v-if="allergens" class="ingredient-container">
                            <p><strong>ALLERGENS:</strong> {{allergens}}</p>
                        </div>
                </div>
            </div>
            <div class="recommendation-container">
                <p class="title">Add more gifts:</p>
                <div class="recommended-addons-container no-scrollbar">
                    <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                        <img @click="changeAddon(addon)" :src="addon.image.src" class="main-image">
                        <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                        <p class="addon-title">{{addon.title}}</p>
                        <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                    </div>
                </div>
            </div>
            <div v-if="showModal" class="add-addon-container">
                <p @click="changeMinBoxQty" v-if="customAlert != ''" v-html="customAlert" class="red-alert"></p>
                <button :disabled="!canAddMore" @click="updateMainAddonProductQuantity(1)" v-show="currentQty == 0" class="happybox-button green border"> {{addCopy}} - {{productPrice | moneySaleFormat}}</button>
                <div :class="!canAddMore ? 'no-more' : ''" class="quantity-container" v-show="currentQty > 0">
                    <button @click="updateProductQuantity(false)">-</button>
                    <p>{{currentQty}} in box</p>
                    <button v-tooltip="{content: limitMessage, container: false}" :class="canAddMore ? 'disabled' : ''" @click="updateProductQuantity(true)">+</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
import VueSlickCarousel from 'vue-slick-carousel'
import Swal from 'sweetalert2/dist/sweetalert2.js'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    components: {
        VueSlickCarousel,
    },
    mixins: [smoothReflow],
    props: {
        selectedAddon: Object,
        addonProducts: Array,
        cartProducts: Array,
        recommendedProducts: Array,
        showModal: Boolean
    },
    data() {
      return {
            selectedImage: null,
            selectedVariant: 0,
            startingY: 0,
            customAlert: '',
            oosProducts: [],
            oldBoxQty: 0,
      }
    },
    computed:{
        ...mapGetters([
          'maxCapacity',
          'currentCapacity',
          'productLimit',
          'addCopy'
        ]),
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        productPrice(){
            return this.selectedAddon.variants.find(x => x.price != "").price
        },
        currentMainImage(){
            if(this.selectedImage){
                return this.selectedImage;
            }
            else {
               return this.selectedAddon.images[0].src
            }
        },
        currentMainImageIndex(){
            if(this.selectedImage){
                let index = this.selectedAddon.images.findIndex(x => x.src == this.selectedImage)
                if(index > -1)
                    return index
            }

            return 0
        },
        recommendedAddons(){
            return this.recommendedProducts.filter(x => x.id != this.selectedAddon.id);
        },
        mainBadge(){
            //Check badges in the following order. 
            //Almost gone: Invetory < 20
            //Best seller: has "Filter_Badges_Best Seller" tag
            // New: has been published for less that 60 days
            var inventory =  this.currentVariantInventory;
            if(inventory < 20)
                return "Less than 20";

            var badge = this.selectedAddon.tags.find(y => y.includes("Filter_Badges"));
            if(badge){
                badge = badge.replace("Filter_","").split("_")
                return badge[1];
            }

            return null
        },
        currentQty(){
            var product = {};
            if(this.isOnDemand)
                product = this.cartProducts.find(x => x.id == this.currentVariantProduct.id);
            else
                product = this.cartProducts.find(x => x.variants[0].id == this.currentVariantProduct.variants[0].id);
            if(product)
                return product.quantity
            return 0
        },
        productMaxQty(){
            //Get max value posible in products, no more than the product limit per box
            var maxValues = [this.productLimit]
            //Get limit based on inventory * total boxes
            maxValues.push(Math.floor(this.currentVariantInventory / this.boxQty));
            //Get limit based on currentCapacity
            maxValues.push(Math.floor(((this.maxCapacity - this.currentCapacity) / this.selectedAddon.capacity) + this.currentQty));

            return Math.min(...maxValues)
        },
        currentAddonIndex(){
            if(this.selectedAddon){
                let index = this.addonProducts.findIndex(x => x.id == this.selectedAddon.id)
                if(index > -1)
                    return index
            }

            return 0
        },
        ethosTags(){
            if(this.selectedAddon){
                var ethos = this.selectedAddon.tags.filter(y => y.includes("Filter_Ethos"));
                ethos = ethos.map((x) => {
                    var currentEthos = x.replace("Filter_","").split("_")
                    return currentEthos[1]
                })
                return ethos;
            }

            return []
        },
        dietaryTags(){
            if(this.selectedAddon){
                var dietary = this.selectedAddon.tags.filter(y => y.includes("Filter_Allergen"));
                dietary = dietary.map((x) => {
                    var currentDietary = x.replace("Filter_","").split("_")
                    return currentDietary[1]
                })
                return dietary;
            }

            return []
        },
        canAddMore(){
            return this.productMaxQty >= this.currentQty + 1;
        },
        hasVariants(){
            return this.selectedAddon.variants.length > 1 && this.selectedAddon.variants.every(x => !x.sku.toLowerCase().includes("ondemand"));
        },
        currentVariantProduct(){
            if(this.isOnDemand){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                let currentQty = this.cartProducts.find(x => x.id == variantProduct.id);
                currentQty = currentQty ? currentQty.quantity : 0;
                if(notDemand.inventory_quantity >= currentQty * this.boxQty  || this.demandQtyMin > this.boxQty * currentQty){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                return variantProduct;
            }
            else if(this.hasVariants){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                variantProduct.variants = [variantProduct.variants[this.selectedVariant]]

                return variantProduct;
            }
            return this.selectedAddon;
        },
        currentVariantInventory(){
            if(this.isOnDemand)
                return 9999;
            return this.currentVariantProduct.variants[0].inventory_quantity;
        },
        productPrice(){
            return this.selectedAddon.variants.find(x => x.price != "").price
        },
        allergens(){
            var splitDesc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;");
            if(splitDesc.length > 1){
                return splitDesc[1].replace( /(<([^>]+)>)/ig, '').replaceAll('&amp;','&').replaceAll('&nbsp;',' ');
            }

            return null
        },
        limitMessage(){
          if(this.maxCapacity < (this.currentCapacity + this.selectedAddon.capacity))
            return 'Your Box is too full!';
          if((this.boxQty * (this.currentQty + 1)) > this.selectedAddon.variants[0].inventory_quantity)
            return 'Not enough inventory';
          if(this.currentQty >= this.productLimit)
            return 'Item limit per box'

          return ''
        },
        isCustom(){
            return this.selectedAddon.tags.some(x => x.includes("Customizable"))
        },
        hasQtyMin(){
            return this.selectedAddon.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
        },
        hasDemandQtyMin(){
            return this.selectedAddon.tags.find(x => x.includes("DEMAND_QTYMIN"));
        },
        isOnDemand(){
            return this.selectedAddon.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        showOnDemand(){
            if(this.isOnDemand){
                if(this.currentVariantProduct)
                    return this.currentVariantProduct.variants[0].sku.toLowerCase().includes("ondemand");
            }

            return false;
        },
        customQtyMin(){
            if(this.hasQtyMin){
                let minTag = this.selectedAddon.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
        demandQtyMin(){
            if(this.hasDemandQtyMin){
                let minTag = this.selectedAddon.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
        productDesc(){
            var desc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;")[0];
            return desc;
        },
    },
    methods:{
        closeModal(){
            if(this.oosProducts.length > 0){
                this.openBoxConfirmation();
                return;
            }
            this.selectedImage = null;
            this.$emit("closemodal");
        },
        getProductCurrentQty(currentProduct){
          var product = this.cartProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateMainAddonProductQuantity(quantity){
            this.customAlert = '';
            if(this.hasQtyMin){
                if(this.customQtyMin > this.boxQty){
                    this.customAlert = `This product requires a minimum order of ${this.customQtyMin}. <strong style='font-weight: 400; text-decoration: underline;'>Click here to update your box quantity.</strong>`;
                    return;
                }
            }
            let maxQty = 0;
            if(this.demandQtyMin > 0){
                if((this.boxQty * quantity) >= this.demandQtyMin)
                    maxQty = 9999;
                else{
                    let notDemand = this.selectedAddon.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                    var maxValues = [this.productLimit]
                    //Get limit based on inventory * total boxes
                    maxValues.push(Math.floor(notDemand.inventory_quantity / this.boxQty));
                    //Get limit based on currentCapacity
                    maxValues.push(Math.floor(((this.maxCapacity - this.currentCapacity) / this.selectedAddon.capacity) + this.currentQty));

                    maxQty = Math.min(...maxValues)
                }
            }
            else
                maxQty = this.productMaxQty;
            var maxPosible = Math.min(quantity,maxQty);
            this.updateAddonProduct(this.currentVariantProduct, maxPosible)
        },
        updateProductQuantity(increment){
            if(increment){
                if(this.canAddMore)
                this.updateMainAddonProductQuantity((this.currentQty + 1))
            }
            else{
                this.updateMainAddonProductQuantity((this.currentQty - 1))
            }
        },
        updateReccomendedAddonProductQuantity(product){
            var isBrandable = product.tags.filter(y => y.includes("Brandable Swag"));
            if(isBrandable && isBrandable.length > 0){
                this.changeAddon(product);
                return;
            }
            var productQty = this.getProductCurrentQty(product) + 1;
            this.updateAddonProduct(product,productQty)
            this.closeModal();
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        updateAddonProduct(product,quantity){
            if(this.isOnDemand){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if((notDemand.inventory_quantity >= quantity * this.boxQty && notDemand.inventory_quantity >= this.boxQty) || this.demandQtyMin > this.boxQty ){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                this.$store.commit('updateSelectedAddonProductsNew',{product: this.currentVariantProduct, quantity: 0});
                this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: quantity});
            }
            else 
                this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: quantity});
        },
        changeAddon(addon){
            if(this.oosProducts.length > 0){
                this.openBoxConfirmation();
                return
            }
            this.selectedImage = null;
            this.$emit("changeselectedaddon", addon);
            this.$nextTick(() => {
                this.$refs.addonModal.scrollTop = 0;
            });
        },
        selectVariant(i){
            this.selectedVariant = i;
        },
        dragStart(event){
            this.startingY = event.touches[0].screenY;
        },
        dragEnd(event){
            if((event.changedTouches[0].screenY - this.startingY) > 100)
                this.closeModal();
        },
        //Change box qty
        changeMinBoxQty(){
            var canUpdate = this.cartProducts.filter((x) =>{
                if((this.customQtyMin * (x.quantity)) >= x.variants[0].inventory_quantity)
                    return true

                return false
            })

            if(canUpdate.length > 0){
                this.oosProducts = canUpdate;
                this.oldBoxQty = this.boxQty;
                //this.openBoxQtyConfirmation(canUpdate);
            }

            this.boxQty = this.customQtyMin;
            this.customAlert = '';
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = "The following product(s) don't have enough inventory to match the quantity of boxes you've requested: " + productTitles.join(", ") + ". Here are your options:";
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll take what you have (& reduce my number of boxes)",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.customAlert = '';
                    this.oosProducts = [];
                } else {
                    this.boxQty = this.oldBoxQty;
                    this.oosProducts = [];
                }
            })
        },
        openBoxConfirmation(){
            if(this.oosProducts.length > 0){
                this.openBoxQtyConfirmation(this.oosProducts);
            }
        },
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        badgeExtraClass(badge){
          switch(badge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        }
    },
    mounted(){
        this.$smoothReflow({
            property: ['height'],
            transition: 'height 1s'
        });
    },
}
</script>

<style lang="scss" scoped>

.iframe-container{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.close-iframe{
    font-size: 8vw;
    cursor: pointer;
    position: absolute;
    top: 0%;
    right: 5%;
}

.empty-space{
    padding: 2% 0%;
    box-shadow: inset 0px -1px 0px #e6e8ec;
    width: 100%;
    position: sticky;
    top: -2%;
    z-index: 2;
    background-color: white;
    text-align: right;
}

.empty-space img{
    width: 5%;
}

.slick-prev:before, .slick-next:before{
    content: none !important;
}

.slick-arrow{
    width: 8vw;
    z-index: 1; 
}

.slick-prev{
    left: 0px;
} 
.slick-next{
    right: 0px;
}

.slick-arrow img{
    width: 100%;
}
.addon-modal-page{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 4;
    overflow-y: scroll;
}

.addon-modal-page.collapsed{
    height: 0%;
}

.addon-modal-container{
    width: 100%;
    background-color: white;
    height: 85%;
    margin-bottom: 0px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 3%;
    padding-bottom: 20%;
}

.addon-modal-container::-webkit-scrollbar{
    width: 0;
}

.addon-container{
    width: 100%;
    display: flex;
    flex-direction: column;
}

.images-container{
    position: relative;
    display: inline-block;
    max-width: 100%;
}

.main-badge{
    background-color: white;
    position: absolute;
    top: 2%;
    left: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1%;
    font-size: 1rem;
    font-weight: bold;
}

.addon-container .main-image{
    background-color: #f6f6f6;
}

.main-image{
    width: 100%;
}

.arrow-right,.arrow-left{
    position: absolute;
    top: 42%;
    font-size: 2rem;
    color: black;
}

.arrow-right{
    right: 3%;
}

.arrow-left{
    left: 3%;
}

.extra-images-container{
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.extra-image{
    width: 15%;
    margin: 0% 2.5%;
    background-color: #f6f6f6;
}

.extra-image.selected{
    border: 1px solid black;
}


.data-container{
    width: 100%;
}

.data-container .title{
    font-size: 1.5rem;
    font-weight: bold;
}

.data-container .desc-label{
    margin: unset;
    text-align: left;
    width: 100%;
    font-size: 3.5vw;
    font-weight: bold;
}

.data-container .desc{
    font-size: 3vw;
    border-radius: 8px;
    padding: 2%;
    background-color: #f6f6f6;
}

.ethos-container, .alergen-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: 2% 0%;
}

.ethos-container span,.alergen-container span{
    background-color: white;
    border: 1px solid #F3EEFA;
    border-radius: 4px;
    padding: 4px 8px;
    color: #5981d9;
    font-size: 1rem;
    line-height: 1.3;
    margin-right: 3%;
}

.ethos-container span.pink{
  background-color: #fbdaff;
}

.ethos-container span.green{
  background-color: #d8efdf;
}

.ethos-container span.yellow{
  background-color: #ffe7c7;
}

.ethos-container span.dgreen{
  background-color: #a9ffbd;
}

.ethos-container span.lyellow{
  background-color: #fffcdd;
}

.ethos-container .purple-ethos{
    background-color: #e3d8f6;
}

.ethos-container .purple-ethos{
    background-color: #e3d8f6;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.recommendation-container .title{
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    border-bottom: 1px solid lightgray;
    margin-bottom: .5rem;
    padding-bottom: .5rem;
}

.recommended-addons-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
}

.recommended-addon{
    width: 40%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: 5%;
}

.addon-title{
    font-weight: bold;
    line-height: 1.2;
    font-size: 1rem;
    margin-top: 5%;
}

.recommended-addon .price{
    font-size: 1rem;
}

.happybox-button.white{
    padding: 3% 0%;
}

.add-addon-container{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0%;
    background-color: white;
    box-shadow: inset 0px 1px 0px #e6e8ec;
}

.add-addon-container .happybox-button.green{
    width: 90%;
    margin: 3% 0% 3% 5%;
    font-size: 1rem;
}

.quantity-container{
    margin: 4% 0%;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
}

.quantity-container button{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    font-size: 2rem;
    line-height: 1.51;
    color: #0F0C38;
    border-radius: 50px;
    height: 3.2rem;
    width: 3.2rem;
}

.quantity-container button.disabled{
    opacity: 0.6;
}

.quantity-container p{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1%;
    font-size: 1.2rem;
    font-weight: bold;
    color: #0F0C38;
    border: unset;
}

.variant-container{
    width: 100%;
}

.variant-title{
    font-weight: 700;
    font-size: 4vw;
    line-height: 1.5;
    color: #0f0c38;
    padding: 2% 0%;
}

.variants-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.variants-button-container button{
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    height: 8vw;
    width: 8vw;
    font-size: 5vw;
    border: 1px solid;
    color: #0f0c38;
    margin-right: 2%;
}

.variants-button-container button.selected{
    background-color: #F3EEFA;
}

.ingredient-container{
    font-size: 3vw;
    margin: 5% 0%;
}
.red-alert{
    color: #581C87;;
    font-size: 4vw;
    text-align: center;
    line-height: 1.2;
    margin-top: 3%;
}

.custom-image-container{
    width: 100%;
    text-align: center;
    padding-bottom: 5%;
}

.custom-image-container p{
    font-size: 7vw;
    font-family: 'moret';
    font-weight: 300;
}

.custom-image-container img{
    width: 80%;
}

.custom-image-container .happybox-button{
    width: 80%;
}
</style>